import { Component, Input } from '@angular/core';

@Component({
    selector: 'ojeu-title',
    template: '<span class="ojeu-section-number">{{sectionNumber}})</span><span class="ojeu-title">{{title}}</span>'
})
export class OjeuTitleComponent {
    @Input() sectionNumber: string;
    @Input() title: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/section.title.component.ts